import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToHealthQuote,
    navigateToLivesCovered,
    navigateToMedicalHistory,
    navigateToDocuments,
    navigateToPayment,
} from '../../../actions/healthInsuranceRW/routing';
import { getActivePageIndex } from '../../../selectors/healthInsuranceRW/routing';
import { PAGE_INDICES } from '../../../actions/healthInsuranceRW/types';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToLivesCovered());
            break;
        case PAGE_INDICES.LIVES_COVERED:
            store.dispatch(navigateToMedicalHistory());
            break;
        case PAGE_INDICES.MEDICAL_HISTORY:
            store.dispatch(navigateToDocuments());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToHealthQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.LIVES_COVERED:
            store.dispatch(navigateToHealthQuote());
            break;

        case PAGE_INDICES.MEDICAL_HISTORY:
            store.dispatch(navigateToLivesCovered());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(navigateToMedicalHistory());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(navigateToDocuments());
            break;
        default:
            store.dispatch(navigateToHealthQuote());
            break;
    }
};
